<!--  -->
<template>
  <div class="TeamMember">
    <div class="member-box">
      <h1>{{ guanli }}</h1>
      <ul class="member-list">
        <li v-for="(item, index) in teamList" :key="index">
          <h1>{{ item.name }}</h1>
          <h2>{{ item.position }}</h2>
          <div class="fenge"></div>
          <p class="msg">{{ item.msg }}</p>
          <br>
          <router-link :to="item.url">
            <span>{{ lookmore }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      guanli: "", //管理团队
      teamList: [
        /* 
        {
          id: 0,
          name: "李晓峰先生",
          position: "董事会主席兼首席执行官",
          msg: "公司董事会主席兼首席执行官。自二零零六年七月十四日起一直担任董事，并自二零零八年四月至二零一零年七月期间担任本公司首席执行官及自二零一二年九月二十日起重新担任本公司首席执行官。",
        },
        {
          name: "李晓峰先生",
          position: "董事会主席兼首席执行官",
          msg: "公司董事会主席兼首席执行官。自二零零六年七月十四日起一直担任董事，并自二零零八年四月至二零一零年七月期间担任本公司首席执行官及自二零一二年九月二十日起重新担任本公司首席执行官。",
        },
        {
          name: "李晓峰先生",
          position: "董事会主席兼首席执行官",
          msg: "公司董事会主席兼首席执行官。自二零零六年七月十四日起一直担任董事，并自二零零八年四月至二零一零年七月期间担任本公司首席执行官及自二零一二年九月二十日起重新担任本公司首席执行官。",
        },
        {
          name: "李晓峰先生",
          position: "董事会主席兼首席执行官",
          msg: "公司董事会主席兼首席执行官。自二零零六年七月十四日起一直担任董事，并自二零零八年四月至二零一零年七月期间担任本公司首席执行官及自二零一二年九月二十日起重新担任本公司首席执行官。",
        },
       */
      ],
      lookmore: "", //了解更多
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //1.文章列表
    get_data() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 10,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.guanli = obj.yj_name;
            $.each(obj.data, function (i, k) {
              that.teamList.push({
                name: k.title,
                position: k.sign,
                msg: k.description,
                url: "/teamparticulars?id=" + k.id,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.lookmore = obj.data["ljgd"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_data();
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.TeamMember {
  width: 100%;
  .member-box {
    width: $main-width;
    margin: 20px auto 80px;
    h1 {
      font-size: 1.4rem;
      color: #333;
    }
    .member-list {
      li {
        margin-top: 50px;
        h1 {
          font-size: 1.2rem;
          color: #333;
        }
        h2 {
          margin-top: 10px;
          font-size: 1rem;
          color: #999;
        }
        .fenge {
          margin-top: 30px;
          width: 421px;
          height: 1px;
          background: #999999;
        }
        p {
          display: inline-block;
          margin-top: 30px;
          font-size: 1rem;
          color: #666;
        }
        a {
          display: inline-block;
        }
        span {
          margin-top: 20px;
          display: inline-block;
          color: #999;
          font-size: 0.9rem;
          transition: 0.3s;
          position: relative;
        }
        span::after {
          content: "";
          width: 0;
          height: 1px;
          background: #999;
          position: absolute;
          bottom: -2px;
          left: 0;
          transition: 0.3s;
        }
        span:hover {
          color: #193b95;
        }
        span:hover::after {
          background: #193b95;
          width: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .TeamMember {
    .member-box {
      width: 100%;
      padding: 0 10px;
      .member-list li .fenge{
        width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/team/TeamMember.vue